// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-bar-link{margin-left:2rem;font-size:1.0675rem}.navigation-bar-link .navbar-nav a{color:#fff}`, "",{"version":3,"sources":["webpack://./src/components/NavigationBarLink/index.scss"],"names":[],"mappings":"AAAA,qBACE,gBAAA,CACA,mBAAA,CAEE,mCACE,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
